import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Role, RoleForm } from '../../models/role';
import { ApiError, Pagination } from '../../models/base';

export const RolesActions = createActionGroup({
  source: 'roles',
  events: {
    // === FETCH ALL ===
    'Fetch All': emptyProps(),
    'Fetch All Success': props<{ items: Role[] }>(),
    'Fetch All Failure': props<{ error: ApiError }>(),

    // === FETCH PAGINATED ===
    'Fetch Paginated': props<{
      page: number;
      limit: number;
      search?: string;
      sort?: Record<string, 'asc' | 'desc'>;
      dateFrom?: string;
      dateTo?: string;
    }>(),
    'Fetch Paginated Success': props<{ items: Role[]; pagination: Pagination }>(),
    'Fetch Paginated Failure': props<{ error: ApiError }>(),

    // === TOGGLE STATUS ===
    'Toggle Status': props<{ id: number }>(),
    'Toggle Status Success': props<{ Role: Role }>(),
    'Toggle Status Failure': props<{ error: ApiError }>(),

    // === CREATE ===
    Create: props<{ Role: RoleForm }>(),
    'Create Success': props<{ Role: Role }>(),
    'Create Failure': props<{ error: ApiError }>(),

    // === UPDATE ===
    Update: props<{ id: number; changes: Partial<RoleForm> }>(),
    'Update Success': props<{ Role: Role }>(),
    'Update Failure': props<{ error: ApiError }>(),

    // === DELETE ===
    Delete: props<{ id: number }>(),
    'Delete Success': props<{ id: number }>(),
    'Delete Failure': props<{ error: ApiError }>(),
  },
});
